import { render, staticRenderFns } from "./Unconfigured.vue?vue&type=template&id=f902684a&"
import script from "./Unconfigured.vue?vue&type=script&lang=js&"
export * from "./Unconfigured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports